
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { routerNames, documentType } from "@/common/js/const";
import { setToken, getToken } from "@/common/js/common";
import conf from "./../../config/base.js";
import Clipboard from "clipboard";
import regexpValid from "@/common/js/regexp.js";
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: routerNames.InvoiceDetail,
directives: {
TransferDom
},
components: {
Group,
Cell,
Divider,
CellBox,
XHeader,
Icon,
Box,
XButton,
CellFormPreview,
Actionsheet,
Previewer,
XDialog
},
data() {
return {
imageSlide1: [
{
src: "",
msrc: "",
alt: "",
title: "",


pid: "image-one"
}
],
documentType: documentType,
showSellerDetail: false,
showBuyerDetail: false,
showGoodsDetail: false,
showElectricOpt: false,
showEmail: false,
showWxCard: false,

invoiceInfo: {
invoiceId: "",
invoiceCode: "",
invoiceNo: "",
price: "",
groupFlag: "",
pdfAddr: "", //pdf地址
typeName: "增值税电子普通发票",
totalTaxAmount: "",
thumbnail: "", //图片地址
buyerEmail: "",
buyerName: "",
buyerFormDetail: [
{
label: this.$t("名称"),
value: ""
},
{
label: this.$t("税号"),
value: ""
},
{
label: this.$t("开户行"),
value: ""
},
{
label: this.$t("银行账号"),
value: ""
},
{
label: this.$t("电话"),
value: ""
},
{
label: this.$t("地址"),
value: ""
}
],
sellerName: "",
sellerFormDetail: [
{
label: this.$t("名称"),
value: ""
},
{
label: this.$t("税号"),
value: ""
},

{
label: this.$t("开户行"),
value: ""
},
{
label: this.$t("银行账号"),
value: ""
},
{
label: this.$t("电话"),
value: ""
},
{
label: this.$t("地址"),
value: ""
}
],
invoiceDetailInfo: [
{
label: this.$t("发票日期"),
value: ""
},
{
label: this.$t("发票号码"),
value: ""
},
{
label: this.$t("发票代码"),
value: ""
}
]
}
};
},
created() {},
mounted() {
var $self = this;
$self.getInvoiceDetail();
document.getElementById("app_body").style["background-color"] = "#2b88d8";
},
beforeRouteLeave(to, from, next) {
document.getElementById("app_body").style["background-color"] = "#fbf9fe";
next();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
methods: {

getInvoiceDetail() {
var $self = this;
var req = $self.$route.name === 'OrderInvoiceDetail' || $self.$route.name === 'QdInvoiceDetail' ? $self.$webapi.getInvoiceById({
invNo: $self.$route.params.invoiceNo.match(/^\d+/)[0],
invCode: $self.$route.params.invoiceCode && $self.$route.params.invoiceCode.match(/^\d+/)[0],
}) : $self.$webapi.getInvoiceByIdDeprecated({
id: $self.$route.params.id,
});
req.then(res => {
$self.$clog(res.data);
if (res.data instanceof Array && res.data.length > 0) {
const invoice = res.data[0];
$self.invoiceInfo.invoiceId = invoice.id;
$self.invoiceInfo.invoiceNo = invoice.invoiceNo;
$self.invoiceInfo.invoiceCode = invoice.invoiceCode;
$self.invoiceInfo.price = invoice.price;
$self.invoiceInfo.groupFlag = invoice.groupFlag;
if (
____isWechatBrowser() &&
($self.invoiceInfo.groupFlag == "IKEA" ||
$self.invoiceInfo.groupFlag == "capitaland" ||
$self.invoiceInfo.groupFlag == "BGY" ||
$self.invoiceInfo.groupFlag == "Walmart")
) {
$self.showWxCard = true;
}
if (['q','c'].includes(invoice.invoiceType) && invoice.businessBillType == "6" && invoice.pdfUrl) {
$self.invoiceInfo.typeName = "增值税电子普通发票";
$self.showElectricOpt = true;
} else if (
invoice.invoiceType == "c" &&
invoice.businessBillType == "8"
) {
$self.invoiceInfo.typeName = "增值税普通发票";
$self.showElectricOpt = false;
} else if (invoice.invoiceType == "s") {
$self.invoiceInfo.typeName = "增值税专用发票";
$self.showElectricOpt = false;
}
$self.invoiceInfo.totalTaxAmount = "￥" + invoice.price;
$self.invoiceInfo.thumbnail =
conf.api.api_root_http +
"/issp/IB/GZ/downloadFile.jsp?httpPath=" +
invoice.imgUrl;
$self.imageSlide1[0].src = $self.invoiceInfo.thumbnail;
$self.imageSlide1[0].msrc = $self.invoiceInfo.thumbnail;
$self.invoiceInfo.pdfAddr = decodeURIComponent(invoice.pdfUrl);
$self.invoiceInfo.buyerName = invoice.buyerName;
$self.invoiceInfo.buyerEmail = invoice.buyerEmail;
var clipboard = new Clipboard(".copy-btn", {
text: function() {
return $self.invoiceInfo.pdfAddr;
}
});
clipboard.on("success", e => {
console.log(e);
$self.$vux.alert.show({
title: $self.$t("提示"),
content: $self.$t("电票文件下载链接已复制到粘贴板"),
onShow() {
console.log("Plugin: I'm showing");
},
onHide() {
console.log("Plugin: I'm hiding now");
}
});
});
clipboard.on("error", e => {
console.log(e);
$self.$vux.alert.show({
title: this.$t("长按下面文字复制"),
content: $self.invoiceInfo.pdfAddr,
onShow() {

},
onHide() {

}
});
});
$self.invoiceInfo.buyerFormDetail = [
{
label: this.$t("名称"),
value: invoice.buyerName
},
{
label: this.$t("税号"),
value: invoice.purchaserTaxNo
},
{
label: this.$t("开户行"),
value: invoice.purchaserBankName
},
{
label: this.$t("银行账号"),
value: invoice.purchaserBankAccount
},
{
label: this.$t("电话"),
value: invoice.purchaserTel
},
{
label: this.$t("地址"),
value: invoice.purchaserAddress
}
];
$self.invoiceInfo.sellerName = invoice.sellerName;
$self.invoiceInfo.sellerFormDetail = [
{
label: this.$t("名称"),
value: invoice.sellerName
},
{
label: this.$t("税号"),
value: invoice.sellerTaxNo
},

{
label: this.$t("开户行"),
value: invoice.sellerBankName
},
{
label: this.$t("银行账号"),
value: invoice.sellerBankAccount
},
{
label: this.$t("电话"),
value: invoice.sellerTel
},
{
label: this.$t("地址"),
value: invoice.sellerAddress
}
];
$self.invoiceInfo.invoiceDetailInfo = [
{
label: this.$t("发票日期"),
value: invoice.handleTime
},
{
label: this.$t("发票号码"),
value: invoice.invoiceNo
},
{
label: this.$t("发票代码"),
value: invoice.invoiceCode
}
];
}
if (res.data.status == 1) {
const invoice = res.data.re;
}
});
},

shareToEmail() {
var $self = this;
$self.$vux.confirm.prompt(this.$t("请输入收票邮箱"), {
title: this.$t("发到邮箱"),
confirmText: this.$t("确定"),
cancelText: this.$t("取消"),
inputAttrs: {
type: "email"
},
onShow() {

$self.$vux.confirm.setInputValue($self.invoiceInfo.buyerEmail);
},
onCancel() {},
onConfirm(newVal) {
if (newVal) {

if (!newVal || !regexpValid.email(newVal)) {
$self.$vux.toast.show({
text: $self.$t("请填写正确的邮箱"),
type: "text"
});
return;
}
$self.$clog("发送到" + newVal);
$self.$webapi
.sendInvoiceEmail($self.invoiceInfo.invoiceId, newVal)
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {

$self.$vux.toast.show({
text: $self.$t("邮件发送成功"),
type: "text"
});
} else {
$self.$vux.toast.show({
text: $self.$t("邮件发送失败，请稍后重试"),
type: "text"
});
}
});
}
}
});
},
wxCard() {
var $self = this;
var url =
conf.api.api_root +
"/issp/wechat/invoice/auth-url-v2.page?orderId=" +
$self.invoiceInfo.invoiceCode +
"_" +
$self.invoiceInfo.invoiceNo +
"&money=" +
$self.invoiceInfo.price +
"&invoiceId=" +
$self.invoiceInfo.invoiceId +
"&redirectUrl=" +
conf.api.api_root_http +
"/xforce/#/orderInvoice/detail/" + $self.invoiceInfo.invoiceNo + '/' + $self.invoiceInfo.invoiceCode;
window.location.replace(url);
},

linkToPicture() {
var $self = this;

$self.$refs.imageSlidePreviewer.show(0);
return false;
}
}
};
